export enum NdsBadgeSize {
  S = 'small',
  M = 'medium',
}

export enum NdsBadgeColor {
  PRIMARY = 'primary',
  WARNING = 'warning',
  SECONDARY = 'secondary',
  DANGER = 'danger',
  NEUTRAL = 'neutral',
  SUCCESS = 'success',
  LIGHT = 'light',
}
